import React from 'react';
import {Button, Form, Icon, Input, message, Select, Tag} from 'antd';
import PropTypes from 'prop-types';
import {createDebounce, getSubFormFieldByTypeForPv, sanitizeFieldName} from '../../util/methods';
import DocumentList from "../AssetStockDocumentList";
import InlineCreateMasterModal from '../InlineCreateMasterModal'
import QrScan from "../QrReader/QRScan";

class SubList extends React.Component {

    id = 0;
    child = React.createRef();
    qrCode = React.createRef();

    state = {
        keys: [],
        keys2: [],
        documentData: {},
        selectedSubType: {},
        disableModelParents: false,
        searchableAssetData: [],
        selectedAssetData: null,
        openCamera: false,
        disableQRCode: false,
        createdPhysicalConditions: [],
        createdAssetCustodians: [],
    };

    componentDidMount() {
        const {data = [{}]} = this.props;
        this.setState({
            keys: data,
        });
        this.props.getAllTagTypes()
    }

    clearDocumentData() {
        this.setState({documentData: {}});
    }

    clearKeys2Data() {
        this.setState({keys2: []});
    }

    getDocumentData = (index, data) => {
        this.props.form.setFieldsValue({[`assetDetails[${index}][fileData]`]: data});
        this.props.updateDocumentData(data);
        this.setState({documentData: data});
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
            this.setState({
                keys: nextProps.data,
            });
        }

        if (nextProps.assetParameterData && JSON.stringify(nextProps.assetParameterData) !== JSON.stringify(this.props.assetParameterData)) {
            let searchData = (nextProps.assetParameterData || []).map(doc => {
                return {
                    id: `${doc.model._id}-${doc.subType._id}-${doc.type._id}`,
                    name: `${doc.model.name} || ${doc.subType.name} || ${doc.type.name}`,
                    modelId: doc.model._id,
                    modelName: doc.model.name,
                    subTypeId: doc.subType._id,
                    subTypeName: doc.subType.name,
                    typeId: doc.type._id,
                    typeName: doc.type.name,
                    isCountable: !!doc.model.isCountable,
                }
            });

            // console.log(searchData);
            searchData = searchData.filter((obj, index, arr) => {
                return index === arr.findIndex((t) => t.id === obj.id && t.name === obj.name);
            });
            this.setState({
                searchableAssetData: searchData,
            });
        }

        if (nextProps.qrUsed && JSON.stringify(nextProps.qrUsed) !== '{}' && JSON.stringify(nextProps.qrUsed) !== JSON.stringify(this.props.qrUsed)) {
            const isUsed = nextProps.qrUsed;
            if (isUsed.status) {
                message.error('QR is already in use!');
                this.setState({loading: false, openCamera: false}, () => {
                    this.props.changeQrAcceptVisible(false);
                    this.props.form.setFieldsValue({[`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}]['tempQrCode']`]: ''});
                });
            }
        }
    }

    removeInterval = (index, idx) => {
        const {keys2} = this.state;
        const {form, filters} = this.props;
        const item = filters && filters['assetDetails'] && filters['assetDetails']['schema']['reading'];
        const val = form.getFieldValue('assetDetails')[`${index}`]['reading'];
        val.splice(idx, 1);
        keys2.splice(index, 1);
        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((itm, kk) => {
                form.setFieldsValue({
                    [`assetDetails[${index}]['reading'][${i}]['${itm}']`]: val[i][`${itm}`],
                });
            });
        }
        this.setState({keys2});
    };

    assetFormItems(index, data) {
        const {form, filters, title, resource} = this.props;
        const {getFieldDecorator} = form;
        const {keys2} = this.state;
        const style = {
            width: '100%',
            marginTop: '10px',
            border: '1px dashed #000',
            padding: '20px',
            borderRadius: '9px',
        };
        return keys2 && keys2.length && keys2.map((k, fIndex) => {

            return <div key={fIndex} style={style}>

                <Form.Item key={`${fIndex}1`} label={'Meter'} style={{width: '100%'}}>
                    {getFieldDecorator(`assetDetails[${index}]['reading'][${fIndex}]['meter']`, {
                        rules: [{required: false, message: `Meter is required!`}],
                        initialValue: (data && data.assetDetails && data.assetDetails[index]['reading'] && data.assetDetails[index]['reading'][fIndex] && data.assetDetails[index]['reading'][fIndex].meter) || '',
                    })(<Input type='number'
                              onWheel={event => event.currentTarget.blur()}
                              disabled={this.props.tempAssetCode !== ''} placeholder={'Meter'}
                              style={{width: '100%'}}/>)
                    }
                </Form.Item>
                <Form.Item key={`${index}2`} label={'Meter Unit'} style={{width: '100%'}}>
                    {getFieldDecorator(`assetDetails[${index}]['reading'][${fIndex}]['meterUnit']`,
                        {
                            rules: [{required: false, message: `Meter Unit is required!`}],
                            initialValue: (data && data.assetDetails && data.assetDetails[index]['reading'] && data.assetDetails[index]['reading'][fIndex] && data.assetDetails[index]['reading'][fIndex].meterUnit) || '',
                        }
                    )(<Select
                        showSearch
                        allowClear
                        mode="single"
                        disabled={this.props.tempAssetCode !== ''}
                        placeholder={`Please Select Meter Unit`}
                        style={{width: '100%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                    >
                        {filters && filters['assetDetails'] && filters['assetDetails']['schema'] && filters['assetDetails']['schema']['reading']['schema']['meterUnit'].data.data.map(item =>
                            <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                    </Select>)
                    }
                </Form.Item>

                {fIndex >= 0 ? (
                    <Icon
                        disabled={this.props.tempAssetCode !== ''}
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        onClick={() => this.removeInterval(index, fIndex)}
                    />
                ) : null}
            </div>
        });
    }

    remove = index => {
        const {keys} = this.state;
        const {form, item} = this.props;
        const {field} = item;
        if (keys.length === 1) {
            return;
        }
        const val = form.getFieldValue(field);
        val.splice(index, 1);

        keys.splice(index, 1);
        for (let i = 0; i < val.length; i++) {
            Object.keys(item.schema).map((item, index) => {
                form.setFieldsValue({
                    [`${field}[${i}][${item}]`]: val[i][item],
                });
            });
        }
        this.setState({
            keys: keys,
        });
    };

    addInterval = () => {
        const {item: {field}} = this.props;
        const {keys2} = this.state;
        keys2.push(`${field}${this.id++}`);
        this.setState({
            keys2: keys2,
        });
    };

    handleModelSelect = (value) => {
        // console.log(value, this.state.searchableAssetData);
        if (value) {
            const selectedParamObject = (this.state.searchableAssetData || []).filter(doc => doc.id === value);
            if (selectedParamObject && selectedParamObject.length) {
                const modelCountable = !!selectedParamObject[0]['isCountable'];
                this.setState({
                    disableType: true,
                    disableSubType: true,
                    countableLocked: modelCountable,
                    selectedAssetData: selectedParamObject[0],
                    selectedSubType: {
                        assetSubType: [{
                            name: selectedParamObject[0]['subTypeName'],
                            _id: selectedParamObject[0]['subTypeId']
                        }],
                        assetType: [{
                            name: selectedParamObject[0]['typeName'],
                            _id: selectedParamObject[0]['typeId']
                        }],
                        assetModel: [{
                            name: selectedParamObject[0]['modelName'],
                            _id: selectedParamObject[0]['modelId']
                        }]
                    }
                })
                // If the selected model is countable, auto-check the countable checkbox
                // and lock it (model-driven, same as NEW-ASSET details popup).
                if (this.props.form && this.props.form.setFieldsValue) {
                    this.props.form.setFieldsValue({ 'assetDetails[0][countable]': modelCountable });
                }
                if (this.props.changeCountable) {
                    this.props.changeCountable({ target: { checked: modelCountable } });
                }
            }
        } else {
            // cleared selection -> unlock countable, reset to unchecked
            this.setState({ countableLocked: false });
            if (this.props.form && this.props.form.setFieldsValue) {
                this.props.form.setFieldsValue({ 'assetDetails[0][countable]': false });
            }
            if (this.props.changeCountable) {
                this.props.changeCountable({ target: { checked: false } });
            }
        }
    };

    handleSelectAssetType = (values) => {
        this.setState({
            selectedType: values
        });
        this.props.handleSelectAssetType(values);
        this.props.form.setFieldsValue({[`assetDetails[0]['equipmentSubType']`]: ''});
    };

    handleSelectAssetSubType = (values) => {
        const allSubtype = this.props.assetSubTypes;
        if (allSubtype && allSubtype.length) {
            this.setState({
                selectedSubType: allSubtype.filter(s => s._id === values)
            });
        }
        if (values)
            this.props.handleSelectAssetSubType(values);
        this.props.form.setFieldsValue({[`assetDetails[0]['assetModel']`]: ''});
    };

    getIdValue = (value) => {
        if (!value) return '';
        if (typeof value === 'string' || typeof value === 'number') return `${value}`;
        if (typeof value === 'object') return `${value._id || value.id || ''}`;
        return '';
    };

    getNameValue = (value, fallback = '') => {
        if (!value) return fallback;
        if (typeof value === 'string') return value;
        if (typeof value === 'object') return value.name || fallback;
        return fallback;
    };

    handleInlineAssetModelCreated = (index, createdAssetModel) => {
        if (!createdAssetModel || !createdAssetModel._id) {
            return;
        }

        const modelId = this.getIdValue(createdAssetModel._id);
        const modelName = this.getNameValue(createdAssetModel.name, '');
        const subType = createdAssetModel.assetSubType;
        const subTypeId = this.getIdValue(subType);
        const subTypeName = this.getNameValue(subType, 'Unknown Sub Type');
        const assetType = subType && subType.assetType;
        const typeId = this.getIdValue(assetType) || 'na';
        const typeName = this.getNameValue(assetType, 'Unknown Type');

        const optionId = `${modelId}-${subTypeId}-${typeId}`;
        const optionName = `${modelName} || ${subTypeName} || ${typeName}`;
        const newOption = {
            id: optionId,
            name: optionName,
            modelId,
            modelName,
            subTypeId,
            subTypeName,
            typeId,
            typeName,
        };

        this.setState((prevState) => {
            const existingData = prevState.searchableAssetData || [];
            const exists = existingData.find((item) => item.id === newOption.id);
            if (exists) {
                return null;
            }
            return {
                searchableAssetData: [...existingData, newOption],
            };
        }, () => {
            this.props.form.setFieldsValue({
                [`assetDetails[${index}]['assetModel']`]: optionId,
            });
            this.handleModelSelect(optionId);
        });
    };

    mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
        const merged = [...(baseOptions || [])];
        (createdOptions || []).forEach((created) => {
            if (!created || !created._id) {
                return;
            }
            const exists = merged.find((item) => `${item && item._id}` === `${created._id}`);
            if (!exists) {
                merged.push(created);
            }
        });
        return merged;
    };

    getInlineMasterOptions = (model = {}, fieldName = '') => {
        const baseOptions = model && model.data && model.data.data || [];
        if (fieldName === 'physicalCondition') {
            return this.mergeUniqueOptions(baseOptions, this.state.createdPhysicalConditions);
        }
        if (fieldName === 'assetCustodian') {
            return this.mergeUniqueOptions(baseOptions, this.state.createdAssetCustodians);
        }
        return baseOptions;
    };

    handleInlineMasterCreated = (index, fieldName, createdItem) => {
        if (!createdItem || !createdItem._id) {
            return;
        }
        if (fieldName === 'physicalCondition') {
            this.setState((prevState) => {
                const exists = (prevState.createdPhysicalConditions || []).find((item) => `${item._id}` === `${createdItem._id}`);
                if (exists) {
                    return null;
                }
                return {
                    createdPhysicalConditions: [...(prevState.createdPhysicalConditions || []), createdItem],
                };
            });
        }
        if (fieldName === 'assetCustodian') {
            this.setState((prevState) => {
                const exists = (prevState.createdAssetCustodians || []).find((item) => `${item._id}` === `${createdItem._id}`);
                if (exists) {
                    return null;
                }
                return {
                    createdAssetCustodians: [...(prevState.createdAssetCustodians || []), createdItem],
                };
            });
        }
        this.props.form.setFieldsValue({
            [`assetDetails[${index}]['${fieldName}']`]: createdItem._id,
        });
    };

    add = () => {
        const {item: {field}} = this.props;
        const {keys} = this.state;
        keys.push(`${field}${this.id++}`);
        this.setState({
            keys: keys,
        });
    }

    debouncedSearch = createDebounce((searchValue) => {
        // Perform your backend search request here with the searchValue
        // console.log('Searching for:', searchValue);
        this.props.searchAssetParameter(searchValue);
    }, 400); // Adjust the delay (in milliseconds) as needed

    handleSearchModel = (key) => {
        // console.log(key);
        if (key.length >= 3)
            this.debouncedSearch(key);
    }

    // scanner -----

    toggleOpenCamera = () => {
        this.setState({openCamera: !this.state.openCamera});
    };

    renderCamera = () => {
        this.qrCode.current.openImageDialog();
    }

    handleDisableQRCode = (data) => {
        this.setState({disableQRCode: data})
    }

    handleScan = data => {
        if (data) {
            this.setState({loading: false, openCamera: false}, () => {
                this.props.changeQrAcceptVisible(true);
                this.props.form.setFieldsValue({[`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}]['tempQrCode']`]: `qr#${data}`});
            });
        } else {
            this.setState({loading: false, openCamera: false,});
            this.props.changeQrAcceptVisible(false)
            message.error('Invalid QR!');
        }
    };

    // handleScanInIphone = async data => {
    //     // console.log(data);
    //     if (data) {
    //         const assetCode = data.split('assetCode=').pop().split('&')[0];
    //         let {subData} = this.state;
    //         subData = [{assetCode: assetCode}];
    //         this.setState({subData, loading: false}, () => {
    //             this.props.form.setFieldsValue({[`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][tempAssetCode]`]: assetCode});
    //         });
    //     } else {
    //         this.setState({loading: false});
    //         message.error('Please Try again');
    //     }
    // };

    onLoad = (data) => {
        this.setState({loading: true});
    };

    // scanner end

    render() {
        const {
            form,
            item,
            data = [],
            openedBy,
            resource,
            match,
            history,
            getDocumentData,
            title,
            latitude,
            longitude,
            superMaster,
            subMaster,
            tempAssetCode,
            tempQrCode,
            documentData,
            subDocumentFilters,
            tempAssetCodeData,
            assetParameterData,
            qrUsed,
            qrAcceptVisible,
            allTagTypes,
            lastTagType,
            handleTagTypeChange
        } = this.props;
        // console.log(allTagTypes, lastTagType)
        const {field} = item;
        const {getFieldDecorator, setFieldsValue} = form;
        const {keys} = this.state;
        const {changeCountable, checked, filters, assetSubTypes, assetModels} = this.props;
        const style = {
            marginTop: '10px',
            border: '1px dashed #000',
            padding: '10px',
            borderRadius: '9px',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            wordBreak: 'break-all',
        };
        let searchData = this.state.searchableAssetData;
        // const {model, subType, type} = assetParameterData;
        // console.log(qrUsed);

        let dynamicAssetType = null;
        if (this.state.selectedSubType && this.state.selectedSubType.assetSubType
            && this.state.selectedSubType.assetSubType.length) {
            dynamicAssetType = (<><Form.Item key={'dynamic-sub-type'} label={'Asset Sub Type'} style={{width: '48%',}}>
                <Input disabled={true} value={this.state.selectedSubType.assetSubType[0]['name']}
                       style={{width: '88%',}}/>
            </Form.Item>
                <Form.Item key={'dynamic-type'} label={'Asset Type'} style={{width: '48%',}}>
                    <Input disabled={true} value={this.state.selectedSubType.assetType[0]['name']}
                           style={{width: '88%',}}/>
                </Form.Item></>)
        }


        const formItems = keys.map((k, index) => {
            return <div key={index} style={style}>
                {
                    Object.keys(this.props.item.schema).map((fieldName, innerIndex) => {
                        if (fieldName === 'assetType') {
                            return <Form.Item key={'assetType'} label={'Asset Type'}>
                                {getFieldDecorator(`assetDetails[${index}]['assetType']`, {
                                    rules: [{
                                        required: true,
                                        message: `Asset Type is required!`
                                    }],
                                    initialValue: this.state.selectedSubType && this.state.selectedSubType.assetType
                                        && this.state.selectedSubType.assetType.length && this.state.selectedSubType.assetType[0]['_id']
                                })(<Select
                                    showSearch
                                    allowClear
                                    disabled={true} //{tempAssetCode !== '' || this.state.disableModelParents}
                                    mode="single"
                                    // onSelect={this.handleSelectAssetType}
                                    style={{width: '75%'}}
                                    filterOption={(input, option) =>
                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                    }
                                    placeholder={`Please Select Asset Type`}
                                >
                                    {this.state.selectedSubType && this.state.selectedSubType.assetType
                                        && this.state.selectedSubType.assetType.length && this.state.selectedSubType.assetType.map(itm =>
                                            <Select.Option key={itm._id}
                                                           value={itm._id}>{itm.name}</Select.Option>)}
                                </Select>)
                                }
                            </Form.Item>
                        }
                        if (fieldName === 'equipmentSubType') {
                            return <Form.Item key={'equipmentSubType'} label={'Equipment Sub Type'}>
                                {getFieldDecorator(`assetDetails[${index}]['equipmentSubType']`, {
                                    rules: [{
                                        required: true,
                                        message: `Equipment Sub Type is required!`
                                    }],
                                    initialValue: this.state.selectedSubType && this.state.selectedSubType.assetSubType
                                        && this.state.selectedSubType.assetSubType.length && this.state.selectedSubType.assetSubType[0]['_id']
                                })(<Select
                                    showSearch
                                    allowClear
                                    disabled={true} // {!(assetSubTypes && assetSubTypes.length) || tempAssetCode !== '' || this.state.disableModelParents}
                                    mode="single"
                                    // onSelect={this.handleSelectAssetSubType}
                                    style={{width: '75%'}}
                                    filterOption={(input, option) =>
                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                    }
                                    placeholder={`Please Select Equipment SubType`}
                                >
                                    {this.state.selectedSubType && this.state.selectedSubType.assetSubType
                                        && this.state.selectedSubType.assetSubType.length && this.state.selectedSubType.assetSubType.map(itm =>
                                            <Select.Option key={itm._id}
                                                           value={itm._id}>{itm.name}</Select.Option>)}
                                </Select>)
                                }
                                {/*{*/}
                                {/*item.schema[fieldName].options.master ?*/}
                                {/*<MasterModal superMaster={superMaster || false}*/}
                                {/*subMaster={subMaster || false} form2={form}*/}
                                {/*index={index}*/}
                                {/*handleSelectAssetType={this.props.handleSelectAssetType}*/}
                                {/*resource={resource} item={item.schema[fieldName].options.ref}*/}
                                {/*title={'CREATE'} hide={true}/> : ''*/}
                                {/*}*/}
                            </Form.Item>
                        }
                        if (fieldName === 'assetModel') {
                            return <Form.Item key={'assetModel'}
                                              label={'Asset Model'} style={{width: '100%'}}>
                                {getFieldDecorator(`assetDetails[${index}]['assetModel']`, {
                                    rules: [{
                                        required: true,
                                        message: `Asset Model is required!`
                                    }],
                                    // initialValue: this.state.selectedSubType && this.state.selectedSubType.assetModel
                                    // && this.state.selectedSubType.assetModel.length && this.state.selectedSubType.assetModel[0]['_id']
                                })(<Select
                                    showSearch
                                    allowClear
                                    // disabled={!(assetModels && assetModels.length) || tempAssetCode !== ''}
                                    mode="single"
                                    style={{width: '80%'}}
                                    onChange={this.handleModelSelect}
                                    filterOption={(input, option) =>
                                        (option.props.label + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                    }
                                    onSearch={this.handleSearchModel}
                                    placeholder={`Please Select Asset Model`}
                                    optionLabelProp="label"
                                >
                                    {searchData && searchData.length && searchData.map((itm, inx) =>
                                        <Select.Option key={inx} value={`${itm.id}`} label={itm.name}>
                                            <div>
                                                <>
                                                    <Tag color="blue">{itm.modelName}</Tag>
                                                    <Tag color="geekblue">{itm.subTypeName}</Tag>
                                                    <Tag color="purple">{itm.typeName}</Tag>
                                                </>
                                            </div>
                                        </Select.Option>)}
                                </Select>)
                                }
                                {
                                    item.schema[fieldName].options.master ?
                                        <InlineCreateMasterModal
                                            item={item.schema[fieldName].options.ref}
                                            initialAssetSubTypeId={form.getFieldValue(`assetDetails[${index}]['equipmentSubType']`)}
                                            onCreated={(createdAssetModel) => this.handleInlineAssetModelCreated(index, createdAssetModel)}
                                            triggerStyle={{
                                                margin: '0',
                                                marginTop: '0',
                                                marginLeft: '10px',
                                                width: 'calc(100% - 10px)'
                                            }}
                                        /> : ''
                                }
                            </Form.Item>
                        }

                        if ((fieldName === 'physicalCondition' || fieldName === 'assetCustodian')) {
                            if (fieldName === 'assetCustodian' && checked) {
                                return null;
                            }
                            const schemaField = item.schema[fieldName];
                            if (!schemaField || schemaField.type !== 'ObjectID' || (schemaField.options && schemaField.options.hidden)) {
                                return null;
                            }
                            const options = this.getInlineMasterOptions(schemaField, fieldName);
                            return <Form.Item
                                key={fieldName}
                                label={sanitizeFieldName(schemaField.options && schemaField.options.label ? schemaField.options.label : schemaField.field)}>
                                {getFieldDecorator(`assetDetails[${index}]['${schemaField.field}']`, {
                                    rules: [{
                                        required: schemaField.required,
                                        message: `${sanitizeFieldName(schemaField.options && schemaField.options.label ? schemaField.options.label : schemaField.field)} is required!`
                                    }],
                                    initialValue: data && data[index] && data[index][schemaField.field] && data[index][schemaField.field]._id,
                                })(<Select
                                    showSearch
                                    allowClear
                                    disabled={this.props.tempAssetCode !== ''}
                                    mode="single"
                                    style={{width: '75%'}}
                                    filterOption={(input, option) =>
                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                    }
                                    placeholder={`Please Select ${sanitizeFieldName(schemaField.options && schemaField.options.label ? schemaField.options.label : schemaField.field)}`}
                                >
                                    {(options || []).map((option) => (
                                        <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>
                                    ))}
                                </Select>)}
                                {schemaField.options && schemaField.options.master ? (
                                    <InlineCreateMasterModal
                                        item={schemaField.options.ref}
                                        onCreated={(createdItem) => this.handleInlineMasterCreated(index, fieldName, createdItem)}
                                        triggerStyle={{
                                            margin: '0',
                                            marginTop: '0',
                                            marginLeft: '10px',
                                            width: 'calc(100% - 10px)'
                                        }}
                                    />
                                ) : ''}
                            </Form.Item>
                        }

                        if (fieldName !== 'parentAssetCode' && fieldName !== 'assetType' && fieldName !== 'equipmentSubType' && fieldName !== 'assetModel' && fieldName !== 'tag_type') {
                            return getSubFormFieldByTypeForPv(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, {
                                title: 'CREATE',
                                resource,
                                checked,
                                tempAssetCode,
                                changeCountable,
                                countableLocked: this.state.countableLocked,
                                superMaster: (superMaster || false),
                                subMaster: (subMaster || false),
                                setFieldsValue
                            });
                        }
                    })
                }

                {!checked && <Form.Item key={'parentAssetCode'} label='Parent Asset Code'>
                    {getFieldDecorator(`assetDetails[${index}]['parentAssetCode']`, {
                        rules: [{
                            required: false,
                            message: `Parent Asset Code is Required!`
                        }], initialValue: data && data.parentAssetCode,
                    })(<Select
                        showSearch
                        allowClear
                        mode="single"
                        style={{marginRight: 8, width: '75%'}}
                        filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                        placeholder="Please select parent asset code"
                        disabled={tempAssetCode !== ''}
                    >
                        {
                            tempAssetCodeData && tempAssetCodeData.length
                            && tempAssetCodeData.map(item => {
                                return item && item.assetDetails && item.assetDetails.length &&
                                    item.assetDetails.map(itm => {
                                        return <Select.Option
                                            disabled={tempAssetCode !== ''} key={itm.tempAssetCode}
                                            value={itm.tempAssetCode}>{itm.tempAssetCode}
                                        </Select.Option>
                                    });
                            })
                        }
                    </Select>)}
                </Form.Item>
                }

                {
                    !checked && this.state.keys2 && this.state.keys2.length ? <div style={{width: '98%'}}>
                        {this.assetFormItems(index, data)}
                    </div> : <> </>
                }

                {!checked && <Form.Item>
                    <Button type="dashed" disabled={tempAssetCode !== ''} onClick={this.addInterval.bind(this, index)}
                            style={{marginRight: 8, width: '75%'}}>
                        <Icon type="plus"/> Add Asset Reading
                    </Button>
                </Form.Item>
                }

                <div style={{
                    // display: 'flex',
                    // flexDirection: `${this.props.width <= 800 ? 'column' : 'row'}`,
                    width: '100%'
                }}>
                    <div style={{width: '100%'}}>
                        <Form.Item key={'tempQrCode'} label={'QR Id'} style={{marginTop: 10}}>
                            {getFieldDecorator(`assetDetails[${index}]['tempQrCode']`, {
                                initialValue: tempQrCode || '',
                            })(<Input
                                type="text"
                                style={{marginRight: 8, width: '100%', fontWeight: 'bold', color: 'tomato'}}
                                disabled={true}
                            />)}
                        </Form.Item>

                        {qrAcceptVisible &&
                            <Form.Item key={'tag_type'} label={'Tag Type'}>
                                {getFieldDecorator(`assetDetails[${index}]['tag_type']`, {
                                    rules: [{
                                        required: qrAcceptVisible,
                                        message: `Tag Type is Required!`
                                    }],
                                    initialValue: data && data.tag_type || (lastTagType && lastTagType._id || ''),
                                })(<Select mode={'single'} placeholder="Please select Tag Type"
                                           style={{marginRight: 8, width: '100%'}}
                                           // defaultValue={lastTagType && lastTagType._id || ''}
                                           onChange={handleTagTypeChange}
                                           disabled={!qrAcceptVisible}>
                                    {
                                        allTagTypes && (allTagTypes || []).map(tag => {
                                            return (<Select.Option key={tag._id} value={tag._id}>{tag.name}</Select.Option>)
                                        })
                                    }
                                </Select>)}
                            </Form.Item>
                        }

                        {!tempQrCode && !tempAssetCode ?
                            <Form.Item>
                                <Button type={qrAcceptVisible ? 'default' : 'primary'}
                                        htmlType={'button'} onClick={this.toggleOpenCamera}>
                                    {qrAcceptVisible ? 'Scan QR to Update' : 'Scan QR to Attach'}
                                </Button>
                            </Form.Item> : null
                        }
                    </div>

                    <div style={{width: '100%'}}>
                        <Form.Item key={'tempAssetCode'} label={'Temp Id'}>
                            {getFieldDecorator(`assetDetails[${index}]['tempAssetCode']`, {
                                initialValue: tempAssetCode || '',
                            })(<Input
                                type="text"
                                style={{marginRight: 8, width: '100%', fontWeight: 'bold'}}
                                disabled={true}
                            />)}
                            {!tempAssetCode &&
                                <Form.Item>
                                    <Button
                                        disabled={this.props.warning && this.props.warning.code === 201 && title === 'CREATE'}
                                        type="primary" htmlType={'submit'}>
                                        {qrAcceptVisible ? 'Accept QR' : 'Generate Temp Code without QR'}
                                    </Button>
                                </Form.Item>
                            }
                        </Form.Item>
                    </div>
                </div>

                {
                    (this.state.openCamera && !tempQrCode) ?
                        <QrScan handleScan={this.handleScan}
                                renderCamera={this.renderCamera}
                                openCamera={this.state.openCamera} toggleOpenCamera={this.toggleOpenCamera}
                                onLoad={this.onLoad}
                                checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
                                disableQRCode={this.state.disableQRCode} qrCodeRef={this.qrCode}/>
                        : null
                }


                {
                    (tempAssetCode !== '') && <div style={{marginTop: '2%', marginRight: '32%', width: '75%'}}>
                        <DocumentList match={this.props.match} history={this.props.history}
                                      documentData={this.state.documentData}
                                      form={this.props.form}
                                      updateUploadedState={this.props.updateUploadedState} resource={this.props.resource}
                                      getDocumentData={this.getDocumentData.bind(this, index)}/>
                    </div>
                }

            </div>
        });

        return (
            <div className='stock-taking-sublist'>
                {/*{dynamicAssetType}*/}
                {formItems}
                <br/>
            </div>
        );
    }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
    item: PropTypes.object,
};
